<template>
  <div class="px-5 py-5 bg-custom">
    <div class="main-card">
      <warnningComponent
        :textInfo.sync="textWarning"
        :typestatus.sync="typeWarning"
        :alert.sync="showWarnnig"
      ></warnningComponent>
      <p class="mb-0 font-weight-medium">Lecture Access</p>
      <v-row>
        <v-col cols="12" sm="4" md="4" class="pt-0">
          <v-checkbox
            v-model="permission.isDocument"
            label="Document"
            color="primary"
            hide-details
            :disabled="loading"
            @change="saveCompanyAccess"
          ></v-checkbox>
          <v-checkbox
            v-model="permission.isImage"
            label="Image"
            color="primary"
            hide-details
            :disabled="loading"
            @change="saveCompanyAccess"
          ></v-checkbox>
          <v-checkbox
            v-model="permission.isExam"
            label="Exam"
            color="primary"
            :disabled="loading"
            hide-details
            @change="saveCompanyAccess"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pt-0">
          <v-checkbox
            v-model="permission.isBook"
            label="Book"
            color="primary"
            :disabled="loading"
            hide-details
            @change="saveCompanyAccess"
          ></v-checkbox>
          <v-checkbox
            v-model="permission.isWebsite"
            label="Website"
            color="primary"
            :disabled="loading"
            hide-details
            @change="saveCompanyAccess"
          ></v-checkbox>
          <v-checkbox
            v-model="permission.isYoutube"
            label="Youtube"
            color="primary"
            :disabled="loading"
            hide-details
            @change="saveCompanyAccess"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pt-0">
          <v-checkbox
            v-model="permission.isOtherfile"
            label="Otherfile"
            color="primary"
            :disabled="loading"
            hide-details
            @change="saveCompanyAccess"
          ></v-checkbox>
          <v-checkbox
            v-model="permission.isArticle"
            label="Article"
            color="primary"
            :disabled="loading"
            hide-details
            @change="saveCompanyAccess"
          ></v-checkbox>
          <v-checkbox
            v-model="permission.isVideo"
            :disabled="loading"
            label="Video"
            color="primary"
            hide-details
            @change="saveCompanyAccess"
          ></v-checkbox>
        </v-col>
      </v-row>
      <!-- Live -->
      <v-row class="mt-5">
        <v-col cols="12" class="py-0">
          <v-checkbox
            class="font-18 font-weight-medium"
            v-model="checkAll"
            label="Live Access"
            color="primary"
            @change="checkAllLiveAccess"
            :disabled="loading"
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="4" md="4" class="py-0">
          <v-checkbox
            v-model="permission.isChatLivestream"
            label="Chat"
            :disabled="loading"
            color="primary"
            hide-details
            @change="saveCompanyAccess"
          ></v-checkbox>
          <v-checkbox
            v-model="permission.isQuizLivestream"
            label="Quiz"
            :disabled="loading"
            color="primary"
            hide-details
            @change="saveCompanyAccess"
          ></v-checkbox>
          <v-checkbox
            v-model="permission.isCheckNameLivestream"
            label="CheckName"
            color="primary"
            hide-details
            :disabled="loading"
            @change="saveCompanyAccess"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="4" md="4" class="py-0">
          <v-checkbox
            v-model="permission.isVotePollLivestream"
            label="VotePoll"
            :disabled="loading"
            color="primary"
            hide-details
            @change="saveCompanyAccess"
          ></v-checkbox>
          <v-checkbox
            v-model="permission.isPdfLivestream"
            label="PdfLives"
            :disabled="loading"
            color="primary"
            hide-details
            @change="saveCompanyAccess"
          ></v-checkbox>
          <v-checkbox
            v-model="permission.isImageLivestream"
            label="Image"
            :disabled="loading"
            color="primary"
            hide-details
            @change="saveCompanyAccess"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="4" md="4" class="py-0">
          <v-checkbox
            v-model="permission.isWebLivestream"
            label="Other Web Site"
            color="primary"
            :disabled="loading"
            hide-details
            @change="saveCompanyAccess"
          ></v-checkbox>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { fetchCompanyById, updateCompany } from "@/service/company/company";
import warnningComponent from "@/components/warningAlert.vue";
export default {
  components: {
    warnningComponent,
  },
  props: {
    id: {
      type: String,
    },
  },
  mounted() {
    this.getCompany();
  },
  data() {
    return {
      textWarning: "",
      typeWarning: "",
      showWarnnig: false,
      loading: false,
      checkAll: false,
      item_company: [],
      permission: {
        limitUser: 0,
        limitTeacher: 0,
        limitVideo: 0,
        isDocument: false,
        isImage: false,
        isBook: false,
        isWebsite: false,
        isOtherfile: false,
        isArticle: false,
        isExam: false,
        isYoutube: false,
        isVideo: false,
        isLivestream: false,
        isChatLivestream: false,
        isQuizLivestream: false,
        isCheckNameLivestream: false,
        isVotePollLivestream: false,
        isPdfLivestream: false,
        isImageLivestream: false,
        isWebLivestream: false,
      },
    };
  },
  methods: {
    async getCompany() {
      let items = await fetchCompanyById({ idcompany: this.id });
      this.item_company = items.company;
      let {
        limitUser,
        limitTeacher,
        limitVideo,
        isDocument,
        isImage,
        isBook,
        isWebsite,
        isOtherfile,
        isArticle,
        isExam,
        isYoutube,
        isVideo,
        isLivestream,
        isChatLivestream,
        isQuizLivestream,
        isCheckNameLivestream,
        isVotePollLivestream,
        isPdfLivestream,
        isImageLivestream,
        isWebLivestream,
      } = items.company.permission;

      this.permission.isDocument = isDocument;
      this.permission.isImage = isImage;
      this.permission.isExam = isExam;
      this.permission.isBook = isBook;
      this.permission.isWebsite = isWebsite;
      this.permission.isYoutube = isYoutube;
      this.permission.isOtherfile = isOtherfile;
      this.permission.isArticle = isArticle;
      this.permission.isVideo = isVideo;
      this.permission.isChatLivestream = isChatLivestream;
      this.permission.isQuizLivestream = isQuizLivestream;
      this.permission.isCheckNameLivestream = isCheckNameLivestream;
      this.permission.isVotePollLivestream = isVotePollLivestream;
      this.permission.isPdfLivestream = isPdfLivestream;
      this.permission.isImageLivestream = isImageLivestream;
      this.permission.isWebLivestream = isWebLivestream;
      if (
        isChatLivestream &&
        isQuizLivestream &&
        isCheckNameLivestream &&
        isVotePollLivestream &&
        isPdfLivestream &&
        isImageLivestream &&
        isWebLivestream
      ) {
        this.checkAll = true;
      }
    },
    async checkAllLiveAccess() {
      let isChecked = this.checkAll;
      this.permission.isChatLivestream = isChecked;
      this.permission.isQuizLivestream = isChecked;
      this.permission.isCheckNameLivestream = isChecked;
      this.permission.isVotePollLivestream = isChecked;
      this.permission.isPdfLivestream = isChecked;
      this.permission.isImageLivestream = isChecked;
      this.permission.isWebLivestream = isChecked;
      this.saveCompanyAccess();
    },
    async saveCompanyAccess() {
      let params = {
        id: this.id,
        appLogo: this.item_company.appLogo,
        title: this.item_company.title,
        description: this.item_company.description,
        systemEmail: this.item_company.systemEmail,
        contactEmail: this.item_company.contactEmail,
        domainName: this.item_company.domainName,
        externalAccess: this.item_company.externalAccess,
        slugName: this.item_company.slugName,
        register: {
          canRegister: this.item_company.canRegister,
          loginEmail: this.item_company.loginEmail,
          loginGoogle: this.item_company.loginGoogle,
          loginFacebook: this.item_company.loginFacebook,
          loginAppleID: this.item_company.loginAppleID,
        },
        course: {
          courseLimitation: this.item_company.courseLimitation,
          courseLimit: this.item_company.courseLimit,
        },
        user: {
          userLimitation: this.item_company.userLimitation,
          userLimit: this.item_company.userLimit,
        },
        storage: {
          storageLimitation: this.item_company.storageLimitation,
          storageLimit: this.item_company.storageLimit,
        },
        keyIcon: this.item_company.keyIcon,
        coverImg: this.item_company.coverImg,
        logo: this.item_company.logo,
        color: {
          headerColor: this.item_company.headerColor,
          footerColor: this.item_company.footerColor,
          buttonColor: this.item_company.buttonColor,
          themeColor: this.item_company.themeColor,
        },
        permission: this.permission,
      };
      let status = await updateCompany(params);
      if (status.message == "domain duplicate") {
        this.warnnig("domain duplicate", "warning");
      }
      if (status.code == 403) {
        this.warnnig("กรุณากรอกข้อมูลให้ถูกต้อง", "warning");
        return;
      } else {
        this.warnnig("อัพเดตข้อมูลเรียบร้อย", "success");
      }
    },
    warnnig(text, type) {
      (this.textWarning = text), (this.typeWarning = type), (this.showWarnnig = true);
      setInterval(() => {
        this.showWarnnig = false;
        this.loading = false;
      }, 3000);
    },
  },
};
</script>
<style scoped lang="scss">
.font-18 .v-label {
  font-size: 18px !important;
}
.main-card {
  width: 60%;
  margin: 0 auto;
  background: #f0f2f5;
}
</style>
